/* eslint-disable prettier/prettier */
import {
    Button,
    Card, CardActions,
    CardContent,
    CardHeader,
    colors,
    Divider,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {State} from '../../graphql/states.datatypes'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
        marginTop: '2rem',
    },
    content: {
        padding: 0
    },
    inner: {
        [theme.breakpoints.up('md')]: {
            minWidth: 700,
        },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        minWidth: 'unset',
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.error.light,
        '&:hover': {
            backgroundColor: theme.palette.error.main
        }
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
    stateFeeChanged: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
}));

const Results = (props: {
    className?: string,
    states: State[],
    initStates: State[],
    onStateUpdate: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, state: State) => void,
    onSubmit: () => void,
    onDelete: (id?: number) => void,
    isAdmin?: boolean
}) => {
    const {className, states, initStates, onStateUpdate, onSubmit, onDelete, isAdmin, ...rest} = props;
    const classes = useStyles();

    function stateFeeWasChanged(stateId:number){
        // @ts-ignore
        const originalStateValue: State = initStates.find(
            targetState => stateId === targetState.id
        );
        // @ts-ignore
        const newStateValue: State = states.find(
            targetState => stateId === targetState.id
        );

        // NOTE: don't love this, feel it could be simplified
        if (originalStateValue.credit_card_fee === null && newStateValue.credit_card_fee === null){
            return false;
        } else if (originalStateValue.credit_card_fee === null && newStateValue.credit_card_fee !== null){
            return newStateValue.credit_card_fee.fee !== '0';
        } else if (originalStateValue.credit_card_fee && newStateValue.credit_card_fee){
            return originalStateValue.credit_card_fee.fee !== newStateValue.credit_card_fee.fee;
        }
    }

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card style={{width: "50%"}}>
                <CardHeader
                    title={'State Fees'}
                    action={
                        <Button
                            onClick={onSubmit}
                            className={classes.saveButton}
                            variant="contained"
                        >
                            Save
                        </Button>
                    }
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: 100}}>State</TableCell>
                                        <TableCell style={{width: 150}}>Fee</TableCell>
                                        <TableCell style={{width: 150}}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {states.length > 0 && states.map(state => {
                                        const fee = state.credit_card_fee ? state.credit_card_fee.fee : '';
                                        return (
                                            <TableRow key={state.id}>
                                                <TableCell className={ stateFeeWasChanged(state.id) ? classes.stateFeeChanged : ''}>{state.name}</TableCell>
                                                <TableCell>
                                                    <TextField
                                                        id={state.name}
                                                        type="number"
                                                        fullWidth
                                                        name="state_fee"
                                                        onChange={(e) => onStateUpdate(e, state)}
                                                        value={fee}
                                                        variant="outlined"
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                        }}
                                                    ></TextField>
                                                </TableCell>
                                                <TableCell>
                                                    {state.credit_card_fee && state.credit_card_fee.id &&
                                                        <Button
                                                            onClick={() => onDelete(state.credit_card_fee.id)}
                                                            className={classes.deleteButton}
                                                            variant="contained"
                                                        >
                                                            Delete
                                                        </Button>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                <CardActions className={classes.actions}>
                    <Button
                        onClick={onSubmit}
                        className={classes.saveButton}
                        variant="contained"
                    >
                        Save
                    </Button>
                </CardActions>
            </Card>
        </div>
    );
};

export default Results;
